import React, { useState, useEffect, useContext,useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import InputField from '../../../Components/InputField';
import Button from '../../../Components/Button';
import InputSelect from '../../../Components/InputSelect';
import SelectBox from '../../../Components/Select';
import SelectBox1 from '../../../Components/Select1';
import DateRangePicker from '../../../Components/dateRangePicker';
import * as XLSX from 'xlsx';
import { io } from "socket.io-client"; // import socket.io-client

import { jwtDecode } from 'jwt-decode';
import axios from 'axios';
import { toast } from 'react-toastify';

import { GlobalContext } from '../../../GlobalContext';

const UserList = (onSendData) => {

    const navigate = useNavigate();
    const { currentTab, setCurrentTab } = useContext(GlobalContext);
    const { selectedUser, setSelectedUser } = useContext(GlobalContext);

    useEffect(() => {
        setCurrentTab('User list');
    });

    const token = localStorage.getItem('token');

    //--------------mouse drage(resize width)--------------
    const containerRef = useRef(null);
    const [columnWidths, setColumnWidths] = useState([]);
    const [isResizing, setIsResizing] = useState(false);
    const [startX, setStartX] = useState(0);
    const [currentColumnIndex, setCurrentColumnIndex] = useState(null);
    const numberOfColumns = 8; // Adjust this based on your actual number of columns

    useEffect(() => {
        const containerWidth = containerRef.current ? containerRef.current.clientWidth : 0;
        const initialWidth = containerWidth / numberOfColumns; // Divide the container width by the number of columns
        setColumnWidths(Array(numberOfColumns).fill(initialWidth)); // Set initial widths
    }, []);

    const handleMouseDown = (e, index) => {
        e.preventDefault(); // Prevent default behavior
        setIsResizing(true);
        setStartX(e.clientX);
        setCurrentColumnIndex(index);
    };

    const handleMouseMove = (e) => {
        if (isResizing && currentColumnIndex !== null) {
            const newWidths = [...columnWidths];
            const newWidth = newWidths[currentColumnIndex] + (e.clientX - startX);
            newWidths[currentColumnIndex] = Math.max(newWidth, 50); // Prevent column from being too small

            // Calculate total width of columns
            const totalWidth = newWidths.reduce((acc, width) => acc + width, 0);
            const containerWidth = containerRef.current.clientWidth; // Get the container width

            // If total width exceeds container width, adjust the widths proportionally
            if (totalWidth > containerWidth) {
                const excessWidth = totalWidth - containerWidth;
                const adjustment = excessWidth / (newWidths.length - 1); // Adjust all but the resized column

                newWidths.forEach((_, idx) => {
                    if (idx !== currentColumnIndex) {
                        newWidths[idx] = Math.max(newWidths[idx] - adjustment, 50); // Prevent columns from being too small
                    }
                });
            }

            setColumnWidths(newWidths);
            setStartX(e.clientX);
        }
    };

    const handleMouseUp = () => {
        setIsResizing(false);
        setCurrentColumnIndex(null);
    };

    useEffect(() => {
        if (isResizing) {
            window.addEventListener('mousemove', handleMouseMove);
            window.addEventListener('mouseup', handleMouseUp);
        }

        return () => {
            window.removeEventListener('mousemove', handleMouseMove);
            window.removeEventListener('mouseup', handleMouseUp);
        };
    }, [isResizing, currentColumnIndex]);

    const headArray = ['User name', 'IMEI/ICCID', 'Company belonged to','Online',
        'Latest login time', 'Notes', 'Agent note', 'operation'];

    const selectCompany = ['Select a company', 'test'];
    const selectGroupType = ['Please select group type', 'Fixed group', 'User-created groups'];
    const selectType = ['Please select user type', 'single function user', 'VIP User'];
    const selectUserStatus = ['Select user status', 'Terminal account changeable period', 'Terminal account changeable period expired'];
    const selectServiceStatus = ['Select service status', 'Recording inactivated', 'Recording activated', 'GPS inactivated', 'GPS activated',
        'SOS inactivated', 'SOS activated', 'Bounding inactivated', 'Bounding activated', 'Duplex inactivated', 'Duplex activated'];
    const selectAccount = ['Select account status', 'OFF', 'ON'];
    const selectCoordinator = ['Please select', 'OFF', 'ON'];
    const selectGPSstatus = ['Please select', 'OFF', 'ON'];
    const selectPTTstatus = ['Select PTT service status', 'OFF', 'ON'];
    const selectPageArray = ['20/page', '40/page', '60/page', '80/page'];
    
    const [staffData, setStaffData] = useState([]);
    const fetchStaffData = async () => {
        const POCBaseUrl = process.env.REACT_APP_GXIN_POC_BASE_URL;

        if (!POCBaseUrl) {
            throw new Error('API base URL is not defined');
        }

        await axios.post(`${POCBaseUrl}/staffs/get`, {},
            {
                headers: {
                    "Content-Type": "application/json", // Specify content type
                    Authorization: `Bearer ${token}`, // Include the token
                },
            }
        )
        .then(response => {
            setStaffData(response.data.data);
            setFilteredStaffs(response.data.data);
        })
        .catch(error => {
            console.error("There was an error fetching the customer data!", error);
        });
    }
    useEffect(() => {
        fetchStaffData();

        const socket = io(process.env.REACT_APP_GXIN_POC_BASE_URL, {
            transports: ["websocket", "polling"],
            auth: { token }, // Optional: for backend auth
        });
    
        socket.on("staffdata", (data) => {
            // console.log("Received staffdata via socket:", data);
            setStaffData(data);
            setFilteredStaffs(data);
        });
    
        socket.on("connect_error", (err) => {
            console.error("Socket connection error:", err);
        });
    
        // Cleanup
        return () => {
            socket.disconnect();
        };

    }, []);

    //----------------------recharge function card -------------------------
    const [functionCardRechargeOpen, setFunctionCardRecharge] = useState(false);
    const [callBackFunctionCardOpen, setcallBackFunctionCardOpen] = useState(false);
    const [cardButton, setCardButton] = useState('Recording card');
    const handleCardButton = (value) => {
        setCardButton(value);
    }

    const [rechargeStaffData, setRechargeStaffData] = useState({});
    const [staffId, setStaffId] = useState('');
    const handleFunctionCardRecharge = async (id) => {
        setFunctionCardRecharge(true);
        setStaffId(id);
        const POCBaseUrl = process.env.REACT_APP_GXIN_POC_BASE_URL;

        if (!POCBaseUrl) {
            throw new Error('API base URL is not defined');
        }
        const staffId = id;
        await axios.post(`${POCBaseUrl}/staffs/getone`, { staffId },
            {
                headers: {
                    "Content-Type": "application/json", // Specify content type
                    Authorization: `Bearer ${token}`, // Include the token
                },
            }
        )
            .then(response => {
                // console.log('response', response.data, response.data.data.name);
                setRechargeStaffData(response.data.data);
            })
            .catch(error => {
                console.error("There was an error fetching the customer data!", error);
            });
    }

    const handleEditStaffClick = (staffId) => {
        navigate(`/editstaff/${staffId}`); // Use navigate for routing
    };

    const [openUserNote, setOpenUserNote] = useState(false);
    const [openAgentNote, setOpenAgentNote] = useState(false);
    const [editNote, setEditNote] = useState('');
    const handleNoteChnage = (e) => {
        setEditNote(e.target.value);
    }
    const [editAgentNote, setEditAgentNote] = useState('');
    const handleAgentNoteChnage = (e) => {
        setEditAgentNote(e.target.value);
    }
    const handleUserNote = (index) => {
        // console.log('index', index);
        setOpenUserNote(true);
        setEditNote(staffData[index].notes)
    }

    const handleAgentUserNote = (index) => {
        setOpenUserNote(true);
        setEditAgentNote(staffData[index].agent_notes)
    }

    const [searchStaffKey, setSearchStaffKey] = useState('');
    const [filteredStaffs, setFilteredStaffs] = useState(staffData);
    const searchStaff = async () => {
        const filteredStaffData = staffData.filter((staff) => {
            const search = searchStaffKey.toLowerCase();
            return (
                staff.nick_name.toLowerCase().includes(search)
            );
          });
          setFilteredStaffs(filteredStaffData);
    }

    //-------------pagination--------------------
    const [currentPage, setCurrentPage] = useState(1);

    const [rowsPerPage, setRowsPerPage] = useState(20);
    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    const currentRows = staffData.slice(indexOfFirstRow, indexOfLastRow);
    const totalPages = Math.ceil(filteredStaffs.length / rowsPerPage);

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const handleRowPage = (data) => {
        if (data === '20/page') {
            setRowsPerPage(20);
        }
        if (data === '40/page') {
            setRowsPerPage(40);
        }
        if (data === '60/page') {
            setRowsPerPage(60);
        }
        if (data === '80/page') {
            setRowsPerPage(80);
        }
    }
    //-------------------checked event------------------------------
    const [checkedValues, setCheckedValues] = useState([]);
    const [checkedAllValues, setCheckedAllValues] = useState('');

    const handleCheckboxChange = (event) => {
        const value = event.target.value;
    
        // Update checkedValues state
        setCheckedValues((prevValues) => {
            const newCheckedValues = prevValues.includes(value)
                ? prevValues.filter((v) => v !== value) // Uncheck
                : [...prevValues, value]; // Check
    
            // Check if all values are checked
            const idArray = staffData.length > 0 ? staffData.map(item => item._id) : [];
            if (newCheckedValues.length === idArray.length) {
                setCheckedAllValues('all'); // Corrected to use parentheses
            } else {
                setCheckedAllValues(''); // Reset if not all are checked
            }
    
            return newCheckedValues; // Return the updated checked values
        });
    };
    // Handle checkbox all change
    const handleCheckboxAllChange = (event) => {
        const value = event.target.value;
        if(checkedAllValues === '') {
            setCheckedAllValues('all');
            const idArray = staffData.length > 0 ? staffData.map(item => item._id) : [];
            setCheckedValues(idArray);
        }else {
            setCheckedAllValues('');
            setCheckedValues([]);
        }
    };
    //-------------------excel export----------------------------------
    const [exportConfirm, setExportConfirm] = useState(false);
    const [exportAllConfirm, setExportAllConfirm] = useState(false);
    const handleExport = () => {
        setExportConfirm(false);
        const filteredStaffData = staffData.length > 0 ? staffData.filter(staff => checkedValues.includes(staff._id)) : [];
        const newStaffData = filteredStaffData.length > 0 ? filteredStaffData.map(staff => {
            return {
                [headArray[0]]: staff.nick_name || '', // Default to empty string if undefined
                [headArray[1]]: `${staff.imei || ''}/${staff.iccid || ''}`, // Default to empty string if undefined
                [headArray[2]]: staff.company_name || '', // Default to empty string if undefined
                [headArray[3]]: staff.user_type || '', // Default to empty string if undefined
                [headArray[4]]: '', // Placeholder for 'Account changeable period'
                [headArray[5]]: '', // Placeholder for 'Service status'
                [headArray[6]]: '', // Placeholder for 'Number of groups'
                [headArray[7]]: '', // Placeholder for 'Online'
                [headArray[8]]: '', // Placeholder for 'Latest login time'
                [headArray[9]]: staff.notes || '', // Default to empty string if undefined
                [headArray[10]]: staff.agent_notes || '', // Default to empty string if undefined
            };
        }) : []; // Return an empty array if staffData is empty
        // console.log('checked values',checkedValues);
        // console.log('allchecked values',checkedAllValues);
        // console.log('newStaffData',newStaffData);
        // Create a worksheet from the data
        const worksheet = XLSX.utils.json_to_sheet(newStaffData);

        // Create a new workbook and append the worksheet
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

        // Export the workbook
        XLSX.writeFile(workbook, 'data.xlsx');
    }
    const handleSelectedUserExport = () => {
        if(checkedValues.length === 0) {
            toast.warn("Please check the user to be exported!", {
                className: 'centered-toast-warn',
                bodyClassName: 'centered-body',
                autoClose: 2000,
                hideProgressBar: true,
                closeButton: false,
                pauseOnHover: false,
                draggable: true,
              });
        } else {
            setExportConfirm(true);
        }
    }
    const handleAllUserExport = () => {
        setExportAllConfirm(false);
        const newStaffData = staffData.length > 0 ? staffData.map(staff => {
            return {
                [headArray[0]]: staff.nick_name || '', // Default to empty string if undefined
                [headArray[1]]: `${staff.imei || ''}/${staff.iccid || ''}`, // Default to empty string if undefined
                [headArray[2]]: staff.company_name || '', // Default to empty string if undefined
                [headArray[3]]: staff.user_type || '', // Default to empty string if undefined
                [headArray[4]]: '', // Placeholder for 'Account changeable period'
                [headArray[5]]: '', // Placeholder for 'Service status'
                [headArray[6]]: '', // Placeholder for 'Number of groups'
                [headArray[7]]: '', // Placeholder for 'Online'
                [headArray[8]]: '', // Placeholder for 'Latest login time'
                [headArray[9]]: staff.notes || '', // Default to empty string if undefined
                [headArray[10]]: staff.agent_notes || '', // Default to empty string if undefined
            };
        }) : []; // Return an empty array if staffData is empty
        // console.log('checked values',checkedValues);
        // console.log('allchecked values',checkedAllValues);
        // console.log('newStaffData',newStaffData);
        // Create a worksheet from the data
        const worksheet = XLSX.utils.json_to_sheet(newStaffData);

        // Create a new workbook and append the worksheet
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

        // Export the workbook
        XLSX.writeFile(workbook, 'data.xlsx');
    }

    useEffect (() => {
        setSelectedUser(checkedValues);
    },[checkedValues])

    //---------------------user delete------------------------
    const [openDeleteConfirm, setOpenDeleteConfirm] = useState(false);
    const [deleteId, setDeleteId] = useState(null);
    const  userDeleteConfirm = (id) => {
        setOpenDeleteConfirm(true);
        setDeleteId(id);
    }

    const handleUserDelete = async() => {
        const POCBaseUrl = process.env.REACT_APP_GXIN_POC_BASE_URL;

        if (!POCBaseUrl) {
            throw new Error('API base URL is not defined');
        }
        if(!deleteId) return;
        await axios.post(`${POCBaseUrl}/staffs/delete`, { deleteId: deleteId },
            {
                headers: {
                    "Content-Type": "application/json", // Specify content type
                    Token: token,
                },
            }
        )
        .then(response => {
            setDeleteId(null);
            setOpenDeleteConfirm(false);
            fetchStaffData();
        })
        .catch(error => {
            console.error("There was an error fetching the customer data!", error);
        });
    }
    
    return (
        <div className='flex flex-col h-[92%] list-table-scroll'>
            <div className='w-full flex justify-between items-center bg-[#f0f0f0] my-2.5 p-2.5' style={{ fontFamily: 'Liberation Serif' }}>
                <div></div>
                <div className='flex items-center'>
                    <span className='mr-[5px] text-[14px] text-[#5a5655]'>Key words:</span>
                    <div className='flex flex-wrap flex-row flex-1 items-center mt-[5px]'>
                        <InputField name={'name'} value={searchStaffKey} onChange={(e) => { setSearchStaffKey(e.target.value) }} placeholder={'Staff Name'} className={'!w-[250px]'} />
                    </div>
                    <div className='ml-[5px] mt-[5px] flex flex-col justify-center'>
                        <Button children={'Search'} onClick={() => searchStaff()}/>
                    </div>
                </div>
            </div>
            <div className=' w-full flex-1 h-[calc(100%-50px)] border-r-0 border-b-0 bg-[#f0f0f0] overflow-auto' ref={containerRef}>
                <table className='table-fixed border-collapse border border-[#ebeef5]'>
                    <thead className='text-[#909399] font-medium'>
                        <tr className='bg-[#fafafa]' style={{ fontFamily: 'SimSun' }}>
                            <th style={{ width:'50px' }} className='border-collapse border border-[#ebeef5] select-none bg-white py-3 min-w-0 truncate align-middle relative text-left text-sm font-normal'>         
                                <div className='w-[50px] h-full flex justify-center'>
                                    <div className="h-[17px] w-[17px] inline-block relative rounded-[2px] bg-white transition-colors duration-250 ease-[cubic-bezier(.71,-.46,.29,1.46)]">
                                        <input id="checkbox1" 
                                               type="checkbox"
                                               className="h-[17px] w-[17px] rounded-[2px] outline-none horver:border-[blue-500]"
                                               value={'all'} 
                                               onChange={handleCheckboxAllChange}
                                               checked={checkedAllValues === 'all'}
                                        />
                                    </div>
                                </div>
                            </th>
                            {columnWidths.map((width, index) => (
                                <th key={index} style={{ width }} className='border-collapse border border-[#ebeef5] select-none bg-white py-3 min-w-0 truncate align-middle relative text-left text-sm font-normal'>
                                    <div onMouseDown={(e) => handleMouseDown(e, index)} className='cursor-col-resize text-center text-black font-bold break-words leading-[27px] pl-2.5 inline-block relative align-middle pr-2.5 w-full truncate whitespace-normal' style={{ fontFamily: 'Liberation Serif' }}>
                                        {headArray[index]}
                                    </div>
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {filteredStaffs.length > 0 && filteredStaffs.map((staff, Index) => (
                            <tr key={Index} className='bg-[#fafafa]'>
                                <td className='w-[6opx] border-collapse border border-[#ebeef5] select-none bg-white py-2 min-w-0 truncate align-middle relative text-left text-center text-[13px] font-normal'>
                                    <div className='w-[6opx] h-full flex justify-center'>
                                        <div className="h-[17px] w-[17px] inline-block relative rounded-[2px] bg-white transition-colors duration-250 ease-[cubic-bezier(.71,-.46,.29,1.46)]">
                                            <input id="checkbox1" 
                                                   type="checkbox"
                                                className="h-[17px] w-[17px] rounded-[2px] outline-none horver:border-[blue-500]"
                                                value={staff._id}
                                                onChange={handleCheckboxChange} 
                                                checked={checkedValues.includes(staff._id)}
                                            />
                                        </div>
                                    </div>
                                </td>
                                <td className='border-collapse border border-[#ebeef5] select-none bg-white py-2 min-w-0 truncate align-middle relative text-left text-center text-[13px] font-normal'>
                                    {staff.nick_name || ''}
                                </td>
                                <td className='border-collapse border border-[#ebeef5] select-none bg-white py-2 min-w-0 truncate align-middle relative text-left text-center text-[13px] font-normal'>
                                    <div className='p-3'>
                                        <div className='text-[13px] flex justify-start'>M: {staff.imei || ''}</div>
                                        <div className='text-[13px] flex justify-start'>C: {staff.iccid || ''}</div>
                                    </div>
                                </td>
                                <td className='border-collapse border border-[#ebeef5] select-none bg-white py-2 min-w-0 truncate align-middle relative text-left text-center text-[13px] font-normal'>
                                    {staff.company_id && staff.company_id.name || ''}
                                </td>
                                <td className='border-collapse border border-[#ebeef5] select-none bg-white py-2 min-w-0 truncate align-middle relative text-lef text-center text-[13px] font-normal'>
                                    { staff.online_status === 'on' ?
                                    <div className='flex justify-center'>
                                        <img
                                            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAADTklEQVRIS63WW0gUURgH8P85szObWHkhCyWxm2Bt62zb2k2KLuSD+FRQUg+ZJdEFu1FRmZCQdMWsKLpHJJg9RfVQIV0IKonVmXFzfSi7PZSSNV7SdnbmxCyMtJqVNfN45pzvd87hnO87BEP4gsHgCE3TRjPGGMdxrS6Xq+tvhpPfdWKMkUAgkKPr+gpCyIIe9Iz9ylRCQBBP4piTOd9SSmt1Xa/yeDwPBos1KKIoynzGWOVroyXzvlELv1GPT2iNipOMZPioF4u5hUijaXWGYWwWRfFZf2wAYs5eluUDn8mXXRe0i/QZq/vjjpgrm0uzUcit0uMQVyqKYvnPg6IQE1AU5VLAaCo4GD6CTnT+Efi5QwISsJffhYmYcEIUxc3WvyhEluWyoNG8rzRchhBCQwKszjGIQTlfhnFI2yqK4nGzvQ9pbGzMate/PN2ibee+Qv0nwBo0GkmoEI6GhpNYj9vtbupDJEl6Uqmfyn5oPP4vwBqcR3Ox1rH6TmZmZl4EaWhomNFK2p5v0IphwLAF4cHjvHCGxbGRkyOILMvHqvUb26r1GlsAK8gargB5NLfEQup2ayVZTazZVsRHvCjhd9+zEHVlqGBkN7ptRcwDcE44/Y7U1NQI6Rnp35eG8m0FzGDD4ES1cK2bRG64IoeXhJZTBmYrFItYVAlXOqzt+lgYWjemHe22IqlkLE7yFc0Wcq9cO7S4jr2wFZlP52ErX3w9gkiStOO+UXv4tH7WVmSHYxvmkFlFESQYDKao39U3Rdp6vsumE5aIRJwVTnXz4FP70oosy+du6reKLutXbVnNRm49chyLjrjd7p19iN/vTyIOGijV9icF2Mv/gnxkupny3zkF59SMjIzOqFSvKEpOB+u4tUcrFd6zD/8EpZNJ2O/Y1xODmIVWlRxQGSVJyu9C19WK8AnezxqGBM2mM1HMbepxMmGZx+O5/cuiZTVKkjQXBFUP9Eep1/UbA2p7fzmFpGAll49sOvtVOBzO93q9UXdh0IeE+fzp7e3dCYqNstGYUG/U4w17CxUdESMe8RhPxmE6nYYpdHIbYaRS07QKn8/3rf8kfvskMju3tLQMU1U1l1K6AMAUAKOASP5pY4wFANQ6HI67Lpdr0Hr9AyP5VtUDhWkoAAAAAElFTkSuQmCC"
                                            alt=""
                                            style={{ width: '20px' }}
                                        />
                                    </div>
                                    : <div className='flex justify-center'>
                                        <img
                                            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAADHElEQVRIS62WPWzTQBSAn8923J/8NG5Mm7TdAyF1VLUsCIki0QExo4qJpRNDBRKwAAMSDCDEz8jAgNSBrsBApYoFCahQVduNCAMqdIjcpmnd5rexz4cuqqMmIU1ScpKX87v3vXv3/hhoYyUSCY9pmicIIYRl2c1IJJJt5ThzlBAhhInH41MY46sMw0wihIYZhimfsW2b2Lb9ByG0iDGei8VinxrpagjRNO08IeQFz/Ojvb290NXVBRzHVekxTROKxSLkcjnAGC/Ztj0ry/LXWlgdhFqvqupDnufv+Hw+1N3d3dQjhBAoFApgGAbGGN+XZfnR4UNVEArQNO21IAjXRFEElmWbAg4LYIxha2sLSqXSS1mWZ51/VRBVVR+4XK57kiTBgevbghy8FaRSKQq6Icvyc7pXgayurk4AwJeBgQG23RvUWmJZFmxubpYIIbFoNPqjAlEU5bMoimfpI3diZbNZ+kYfRkdHL5chKysrZ3ie/zY4OHhsN9UaRoNB13ViWdbJMkRV1acej+emz+frxCUqOgzDgEwmc9eBLEmSNCEIQkchNKzT6fSCA9kNhUJehFBHITQAdF1fZ+bn513hcHh/eHi4owAnnJPJZI45SEBraGgIHTc3Glln2zYkk8k9x116MBikCdLR29DatrGx8dOBLPT3919spU61YwUtnIZhvC1DFEW55Xa7H/v9/nZ0NJVNp9OQz+dnypBEIhEyTfN3MBjkOxVhtFjqup4jhIxUyoqqqq/cbvdMX19fUwtbEdje3qbl/0k0Gr1dgSwvL0scx8UlSZL+NykPknDd5XKdDofDmapSr2naFELoXSAQcPE834rBdTKlUomW+oJt2xecLlnXGRVFmWZZ9o0oijxtue2sfD4POzs7BYzxlVgs9v6fTcvZVBTlHMMwcz09PSNer7eut9eCaT7s7e3RN/hlWdb02NjY98MyDQcJOv4Ui8XbCKHrgiD46a2oC52EpdFDXbO/v0+/FB06TNN8Nj4+nq814siRiAqvra117e7uXkIITQLAKQAIAAABAKo4DgCLHMd9jEQipUau/Qs7XG3VbpoA+AAAAABJRU5ErkJggg=="
                                            alt=""
                                            style={{ width: '20px' }}
                                        />
                                    </div> 
                                    }
                                </td>
                                <td className='border-collapse border border-[#ebeef5] select-none bg-white py-2 min-w-0 truncate align-middle relative text-lef text-center text-[13px] font-normal'>
                                    {staff.last_login_date || ''}
                                </td>
                                <td className='border-collapse border border-[#ebeef5] select-none bg-white py-2 min-w-0 truncate align-middle relative text-lef text-center text-[13px] font-normal'>
                                    {staff.notes || ''}
                                </td>
                                <td className='border-collapse border border-[#ebeef5] select-none bg-white py-2 min-w-0 truncate align-middle relative text-lef text-center text-[13px] font-normal'>
                                    {staff.agent_notes || ''}
                                </td>
                                <td className='border-collapse border border-[#ebeef5] select-none bg-white py-2 min-w-0 truncate align-middle relative text-left text-center text-[13px] font-normal'>
                                    <div className="text-center box-border overflow-hidden text-ellipsis whitespace-normal break-all leading-[23px] px-[10px]">
                                        {/* <span onClick={() => setFunctionCardRecharge(true)} className='cursor-pointer text-[#2776c3] whitespace-nowrap'>Recharge function card /</span> */}
                                        {/* <span onClick={() => setcallBackFunctionCardOpen(true)} className='cursor-pointer text-[#2776c3] whitespace-nowrap'>Call back function card /  </span> */}
                                        <span onClick={() => handleEditStaffClick(staff._id)} className='cursor-pointer text-[#2776c3] whitespace-nowrap'>Edit</span>
                                        {/* <span onClick={() => userDeleteConfirm(staff._id)} className='cursor-pointer text-[#2776c3] whitespace-nowrap'> Delete</span> */}
                                        {/* <span onClick={() => handleUserNote(Index)} className='cursor-pointer text-[#2776c3] whitespace-nowrap'>edit notes / </span>
                                        <span onClick={() => handleAgentUserNote(Index)} className='cursor-pointer text-[#2776c3] whitespace-nowrap'>edit agent note / </span>
                                        <span className='cursor-pointer text-[#2776c3] whitespace-nowrap'>search</span> */}
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            {/* ------bottom bar-------- */}
            <div className='flex items-center mt-[12px]' style={{ fontFamily: 'Liberation Serif' }}>
                <div className='flex whitespace-nowrap text-[#303133] font-bold'>
                    <span className='inline-block text-[13px] min-w-[35.5px] h-[28px] leading-[28px] align-top mr-2.5 font-normal text-[#606266]'>totally 0 item</span>
                    <div className="flex justify-center items-center">
                        <button
                            onClick={() => handlePageChange(currentPage - 1)}
                            disabled={currentPage === 1}
                            className="w-[30px] h-[28px] bg-[#f4f4f5] rounded-sm hover:cursor-pointer disabled:cursor-not-allowed mr-2 group pl-2"
                        >
                            <svg
                                className="w-3 fill-[#606266] group-disabled:fill-gray-300"
                                viewBox="0 0 55.753 55.753"
                            >
                                <path
                                    d="M12.745 23.915c.283-.282.59-.52.913-.727L35.266 1.581a5.4 5.4 0 0 1 7.637 7.638L24.294 27.828l18.705 18.706a5.4 5.4 0 0 1-7.636 7.637L13.658 32.464a5.367 5.367 0 0 1-.913-.727 5.367 5.367 0 0 1-1.572-3.911 5.369 5.369 0 0 1 1.572-3.911z"
                                    data-original="#000000"
                                />
                            </svg>
                        </button>

                        <div className="flex space-x-2">
                            {[...Array(totalPages).keys()].map((number) => (
                                <button
                                    key={number}
                                    onClick={() => handlePageChange(number + 1)}
                                    className={`w-[30px] h-[28px] rounded-sm text-sm font-medium ${currentPage === number + 1
                                        ? 'bg-blue-600 text-white'
                                        : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                                        }`}
                                >
                                    {number + 1}
                                </button>
                            ))}
                        </div>

                        <button
                            onClick={() => handlePageChange(currentPage + 1)}
                            disabled={currentPage === totalPages}
                            className="w-[30px] h-[28px] bg-[#f4f4f5] rounded-sm hover:cursor-pointer disabled:cursor-not-allowed ml-3 items-center group pl-2"
                        >
                            <svg
                                className="w-3 fill-[#606266] group-disabled:fill-gray-300 rotate-180"
                                viewBox="0 0 55.753 55.753"
                            >
                                <path
                                    d="M12.745 23.915c.283-.282.59-.52.913-.727L35.266 1.581a5.4 5.4 0 0 1 7.637 7.638L24.294 27.828l18.705 18.706a5.4 5.4 0 0 1-7.636 7.637L13.658 32.464a5.367 5.367 0 0 1-.913-.727 5.367 5.367 0 0 1-1.572-3.911 5.369 5.369 0 0 1 1.572-3.911z"
                                    data-original="#000000"
                                />
                            </svg>
                        </button>
                    </div>
                    <span className='inline-block text-[13px] min-w-[35.5px] h-[28px] leading-[28px] align-top font-normal text-[#606266] ml-[5px]'>
                        Go to
                        <div className='w-[50px] inline-block ml-[5px]'>
                            <input
                                type="text"
                                placeholder="1"
                                className="h-[28px] px-1 text-[14px] rounded-md bg-white border border-[#dcdfe6] w-full outline-blue-500 text-center"
                                value={currentPage}
                                onChange={(e) => setCurrentPage(e.target.value)}
                            />
                        </div>
                    </span>
                    <Button children={'Confirm'} className={'!h-[28px] !py-1 !w-[60px] !px-0 ml-[5px]'} />
                    <SelectBox options={selectPageArray} onSendData={handleRowPage} value={'20/page'} className={'!w-[100px] !h-[28px]'} />
                    <button onClick={handleSelectedUserExport} className="ml-3 h-[27px] px-[10px] text-[15px] bg-[#2776c3] border-0 rounded-[3px] text-[white]">Export</button>
                    <button onClick={() => setExportAllConfirm(true)} className="ml-3 h-[27px] px-[10px] text-[15px] bg-[#2776c3] border-0 rounded-[3px] text-[white]">Export All</button>
                </div>
            </div>
            {functionCardRechargeOpen && (
                <div className="fixed inset-0 p-2 flex flex-wrap justify-center items-center w-full h-full z-[1000] before:fixed before:inset-0 before:w-full before:h-full before:bg-[rgba(0,0,0,0.5)] overflow-auto font-[sans-serif]" style={{ fontFamily: 'Liberation Serif' }}>
                    <div className="w-[750px] bg-white shadow-lg rounded-lg p-2 relative">
                        <div className="flex items-center p-5 border-b border-gray-300">
                            <h3 className="text-xl flex-1 text-center text-[#2776c3]">Recharge function card</h3>
                            <svg
                                className="w-3 ml-2 cursor-pointer shrink-0 fill-gray-400 hover:fill-red-500"
                                viewBox="0 0 320.591 320.591"
                                onClick={() => setFunctionCardRecharge(false)} // Close modal on click
                            >
                                <path
                                    d="M30.391 318.583a30.37 30.37 0 0 1-21.56-7.288c-11.774-11.844-11.774-30.973 0-42.817L266.643 10.665c12.246-11.459 31.462-10.822 42.921 1.424 10.362 11.074 10.966 28.095 1.414 39.875L51.647 311.295a30.366 30.366 0 0 1-21.256 7.288z"
                                />
                                <path
                                    d="M287.9 318.583a30.37 30.37 0 0 1-21.257-8.806L8.83 51.963C-2.078 39.225-.595 20.055 12.143 9.146c11.369-9.736 28.136-9.736 39.504 0l259.331 257.813c12.243 11.462 12.876 30.679 1.414 42.922-.456.487-.927.958-1.414 1.414a30.368 30.368 0 0 1-23.078 7.288z"
                                />
                            </svg>
                        </div>

                        <div className='flex justify-center'>
                            <div className='mt-[20px] flex flex-col items-center text-center my-[20px] pr-[30px] border-r border-[#999999]'>
                                <span className='text-center text-[#5a5655] text-[14px]'>Recording card</span>
                                <span className='text-center text-[#5a5655] text-[14px]'>{rechargeStaffData.recording_card || 0} Pieces</span>
                            </div>
                            <div className='mt-[20px] flex flex-col items-center text-center mx-[30px] my-[20px] pr-[30px] border-r border-[#999999]'>
                                <span className='text-center text-[#5a5655] text-[14px]'>GPS card</span>
                                <span className='text-center text-[#5a5655] text-[14px]'>{rechargeStaffData.gps_card || 0} Pieces</span>
                            </div>
                            <div className='mt-[20px] flex flex-col items-center text-center mx-[30px] my-[20px] pr-[30px] border-r border-[#999999]'>
                                <span className='text-center text-[#5a5655] text-[14px]'>Bounding card</span>
                                <span className='text-center text-[#5a5655] text-[14px]'>{rechargeStaffData.bounding_card || 0} Pieces</span>
                            </div>
                            <div className='mt-[20px] flex flex-col items-center text-center my-[20px] pr-[30px] border-r border-[#999999]'>
                                <span className='text-center text-[#5a5655] text-[14px]'>Duplex card</span>
                                <span className='text-center text-[#5a5655] text-[14px]'>{rechargeStaffData.duplex_card || 0} Pieces</span>
                            </div>
                        </div>
                        <div className='text-[14px]'>
                            <div className='flex flex-row items-center m-[20px]'>
                                <span className='w-[160px] text-[#5a5655] text-[14px] text-right'>IMEI:</span>
                                <div className='flex-1 ml-[5px] relative text-[14px] inline-block w-full'>
                                    <input
                                        type="text"
                                        disabled
                                        autoComplete="off"
                                        placeholder={rechargeStaffData.imei || ''}
                                        className="p-0 pl-[15px] w-[480px] h-[40px] text-[#606266] bg-[#f5f7fa] border border-[#e4e7ed] rounded-sm"
                                    />
                                </div>
                            </div>
                            <div className='flex flex-row items-center m-[20px]'>
                                <span className='w-[160px] text-[#5a5655] text-[14px] text-right'>Function cards consumed:</span>
                                <div className='flex-1 ml-[5px] relative text-[14px] inline-block w-full'>
                                    <input
                                        type="number"
                                        autoComplete="off"
                                        placeholder=""
                                        className="p-0 pl-[15px] w-[480px] h-[40px] text-[#606266] bg-[#fff] border border-[#e4e7ed] rounded-sm outline-none"
                                    // onChange={handleCardValue}
                                    />
                                </div>
                            </div>
                            <div className='flex flex-row items-center m-[20px]'>
                                <span className='w-[160px] text-[#5a5655] text-[14px] text-right'>Funcion card type:</span>
                                <span onClick={() => handleCardButton('Recording card')} className={`inline-block ${cardButton === 'Recording card' ? 'border border-[#2776c3] !text-[#2776c3]' : 'border border-[#c2c2c2] text-[#c2c2c2]'} bg-[#f1f1f1] p-[10px] px-[20px] ml-[5px] mr-[5px] rounded-[5px] cursor-pointer`}>
                                    Recording card
                                </span>
                                <span onClick={() => handleCardButton('GPS card')} className={`inline-block ${cardButton === 'GPS card' ? 'border border-[#2776c3] !text-[#2776c3]' : 'border border-[#c2c2c2] text-[#c2c2c2]'} bg-[#f1f1f1] p-[10px] px-[20px] ml-[5px] mr-[5px] rounded-[5px] cursor-pointer`}>
                                    GPS card
                                </span>
                                <span onClick={() => handleCardButton('Bounding card')} className={`inline-block ${cardButton === 'Bounding card' ? 'border border-[#2776c3] !text-[#2776c3]' : 'border border-[#c2c2c2] text-[#c2c2c2]'} bg-[#f1f1f1] p-[10px] px-[20px] ml-[5px] mr-[5px] rounded-[5px] cursor-pointer`}>
                                    Bounding card
                                </span>
                                <span onClick={() => handleCardButton('Duplex card')} className={`inline-block ${cardButton === 'Duplex card' ? 'border border-[#2776c3] !text-[#2776c3]' : 'border border-[#c2c2c2] text-[#c2c2c2]'} bg-[#f1f1f1] p-[10px] px-[20px] ml-[5px] mr-[5px] rounded-[5px] cursor-pointer`}>
                                    Duplex card
                                </span>
                            </div>
                        </div>

                        <div className="pt-10 flex justify-center gap-4 mb-3" style={{ fontFamily: 'Liberation Serif' }}>
                            <button
                                type="button"
                                className="w-[562px] h-[36px] rounded-md text-[white] text-sm border-none outline-none tracking-wide bg-[#2776c3]"
                            // onClick={handleDeposite} // Close modal on click
                            >
                                Renew
                            </button>
                        </div>
                    </div>
                </div>
            )}
            {callBackFunctionCardOpen && (
                <div className="fixed inset-0 p-2 flex flex-wrap justify-center items-center w-full h-full z-[1000] before:fixed before:inset-0 before:w-full before:h-full before:bg-[rgba(0,0,0,0.5)] overflow-auto font-[sans-serif]" style={{ fontFamily: 'Liberation Serif' }}>
                    <div className="w-[750px] bg-white shadow-lg rounded-lg p-2 relative">
                        <div className="flex items-center p-5 border-b border-gray-300">
                            <h3 className="text-xl flex-1 text-center text-[#2776c3]">Call back function card</h3>
                            <svg
                                className="w-3 ml-2 cursor-pointer shrink-0 fill-gray-400 hover:fill-red-500"
                                viewBox="0 0 320.591 320.591"
                                onClick={() => setcallBackFunctionCardOpen(false)} // Close modal on click
                            >
                                <path
                                    d="M30.391 318.583a30.37 30.37 0 0 1-21.56-7.288c-11.774-11.844-11.774-30.973 0-42.817L266.643 10.665c12.246-11.459 31.462-10.822 42.921 1.424 10.362 11.074 10.966 28.095 1.414 39.875L51.647 311.295a30.366 30.366 0 0 1-21.256 7.288z"
                                />
                                <path
                                    d="M287.9 318.583a30.37 30.37 0 0 1-21.257-8.806L8.83 51.963C-2.078 39.225-.595 20.055 12.143 9.146c11.369-9.736 28.136-9.736 39.504 0l259.331 257.813c12.243 11.462 12.876 30.679 1.414 42.922-.456.487-.927.958-1.414 1.414a30.368 30.368 0 0 1-23.078 7.288z"
                                />
                            </svg>
                        </div>

                        <div className='flex justify-center'>
                            <div className='mt-[20px] flex flex-col items-center text-center my-[20px] pr-[30px] border-r border-[#999999]'>
                                <span className='text-center text-[#5a5655] text-[14px]'>Recording card</span>
                                <span className='text-center text-[#5a5655] text-[14px]'>{rechargeStaffData.recording_card || 0} Pieces</span>
                            </div>
                            <div className='mt-[20px] flex flex-col items-center text-center mx-[30px] my-[20px] pr-[30px] border-r border-[#999999]'>
                                <span className='text-center text-[#5a5655] text-[14px]'>GPS card</span>
                                <span className='text-center text-[#5a5655] text-[14px]'>{rechargeStaffData.gps_card || 0} Pieces</span>
                            </div>
                            <div className='mt-[20px] flex flex-col items-center text-center mx-[30px] my-[20px] pr-[30px] border-r border-[#999999]'>
                                <span className='text-center text-[#5a5655] text-[14px]'>Bounding card</span>
                                <span className='text-center text-[#5a5655] text-[14px]'>{rechargeStaffData.bounding_card || 0} Pieces</span>
                            </div>
                            <div className='mt-[20px] flex flex-col items-center text-center my-[20px] pr-[30px] border-r border-[#999999]'>
                                <span className='text-center text-[#5a5655] text-[14px]'>Duplex card</span>
                                <span className='text-center text-[#5a5655] text-[14px]'>{rechargeStaffData.duplex_card || 0} Pieces</span>
                            </div>
                        </div>
                        <div className='text-[14px]'>
                            <div className='flex flex-row items-center m-[20px]'>
                                <span className='w-[160px] text-[#5a5655] text-[14px] text-right'>IMEI:</span>
                                <div className='flex-1 ml-[5px] relative text-[14px] inline-block w-full'>
                                    <input
                                        type="text"
                                        disabled
                                        autoComplete="off"
                                        placeholder={rechargeStaffData.imei || ''}
                                        className="p-0 pl-[15px] w-[480px] h-[40px] text-[#606266] bg-[#f5f7fa] border border-[#e4e7ed] rounded-sm"
                                    />
                                </div>
                            </div>
                            <div className='flex flex-row items-center m-[20px]'>
                                <span className='w-[160px] text-[#5a5655] text-[14px] text-right'>Function cards consumed:</span>
                                <div className='flex-1 ml-[5px] relative text-[14px] inline-block w-full'>
                                    <input
                                        type="number"
                                        autoComplete="off"
                                        placeholder=""
                                        className="p-0 pl-[15px] w-[480px] h-[40px] text-[#606266] bg-[#fff] border border-[#e4e7ed] rounded-sm outline-none"
                                    // onChange={handleCardValue}
                                    />
                                </div>
                            </div>
                            <div className='flex flex-row items-center m-[20px]'>
                                <span className='w-[160px] text-[#5a5655] text-[14px] text-right'>Funcion card type:</span>
                                <span onClick={() => handleCardButton('Recording card')} className={`inline-block ${cardButton === 'Recording card' ? 'border border-[#2776c3] !text-[#2776c3]' : 'border border-[#c2c2c2] text-[#c2c2c2]'} bg-[#f1f1f1] p-[10px] px-[20px] ml-[5px] mr-[5px] rounded-[5px] cursor-pointer`}>
                                    Recording card
                                </span>
                                <span onClick={() => handleCardButton('GPS card')} className={`inline-block ${cardButton === 'GPS card' ? 'border border-[#2776c3] !text-[#2776c3]' : 'border border-[#c2c2c2] text-[#c2c2c2]'} bg-[#f1f1f1] p-[10px] px-[20px] ml-[5px] mr-[5px] rounded-[5px] cursor-pointer`}>
                                    GPS card
                                </span>
                                <span onClick={() => handleCardButton('Bounding card')} className={`inline-block ${cardButton === 'Bounding card' ? 'border border-[#2776c3] !text-[#2776c3]' : 'border border-[#c2c2c2] text-[#c2c2c2]'} bg-[#f1f1f1] p-[10px] px-[20px] ml-[5px] mr-[5px] rounded-[5px] cursor-pointer`}>
                                    Bounding card
                                </span>
                                <span onClick={() => handleCardButton('Duplex card')} className={`inline-block ${cardButton === 'Duplex card' ? 'border border-[#2776c3] !text-[#2776c3]' : 'border border-[#c2c2c2] text-[#c2c2c2]'} bg-[#f1f1f1] p-[10px] px-[20px] ml-[5px] mr-[5px] rounded-[5px] cursor-pointer`}>
                                    Duplex card
                                </span>
                            </div>
                        </div>

                        <div className="pt-10 flex justify-center gap-4 mb-3" style={{ fontFamily: 'Liberation Serif' }}>
                            <button
                                type="button"
                                className="w-[562px] h-[36px] rounded-md text-[white] text-sm border-none outline-none tracking-wide bg-[#2776c3]"
                            // onClick={handleDeposite} // Close modal on click
                            >
                                Recycle
                            </button>
                        </div>
                    </div>
                </div>
            )}
            {openUserNote && (
                <div className="fixed inset-0 p-2 flex flex-wrap justify-center items-center w-full h-full z-[1000] before:fixed before:inset-0 before:w-full before:h-full before:bg-[rgba(0,0,0,0.5)] overflow-auto font-[sans-serif]">
                    <div className="w-[500px] max-w-lg bg-white shadow-lg rounded-lg p-4 relative">

                        <div className="flex justify-center text-[#5a5655] text-[14px]" style={{ fontFamily: 'Liberation Serif' }}>
                            edit user notes
                        </div>
                        <div className='flex justify-center mt-5 mb-5'>
                            <textarea
                                placeholder="Please enter"
                                className="p-4 h-[200px] bg-white max-w-md mx-auto w-full block text-sm border border-gray-300 outline-[#007bff] rounded"
                                rows="4"
                                name={'notes'}
                                value={editNote || ''}
                                onChange={handleNoteChnage}
                            ></textarea>
                        </div>

                        <div className="border-t border-gray-300 pt-1 flex justify-around gap-4" style={{ fontFamily: 'Liberation Serif' }}>
                            <div
                                className="px-4 py-1 rounded-lg text-[#5a5655] text-sm border-none outline-none tracking-wide active:bg-gray-200 cursor-pointer"
                                onClick={() => setOpenUserNote(false)} // Close modal on click
                            >
                                No
                            </div>
                            <div
                                onClick={() => setOpenUserNote(false)}
                                className="px-4 py-1 rounded-lg text-blue-500 text-sm border-none outline-none tracking-wide active:bg-blue-600 cursor-pointer"
                            >
                                Confirm
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {openAgentNote && (
                <div className="fixed inset-0 p-2 flex flex-wrap justify-center items-center w-full h-full z-[1000] before:fixed before:inset-0 before:w-full before:h-full before:bg-[rgba(0,0,0,0.5)] overflow-auto font-[sans-serif]">
                    <div className="w-[500px] max-w-lg bg-white shadow-lg rounded-lg p-4 relative">

                        <div className="flex justify-center text-[#5a5655] text-[14px]" style={{ fontFamily: 'Liberation Serif' }}>
                            edit user notes
                        </div>
                        <div className='flex justify-center mt-5 mb-5'>
                            <textarea
                                placeholder="Please enter"
                                className="p-4 h-[200px] bg-white max-w-md mx-auto w-full block text-sm border border-gray-300 outline-[#007bff] rounded"
                                rows="4"
                                name={'notes'}
                                value={editAgentNote || ''}
                                onChange={handleAgentNoteChnage}
                            ></textarea>
                        </div>

                        <div className="border-t border-gray-300 pt-1 flex justify-around gap-4" style={{ fontFamily: 'Liberation Serif' }}>
                            <div
                                className="px-4 py-1 rounded-lg text-[#5a5655] text-sm border-none outline-none tracking-wide active:bg-gray-200 cursor-pointer"
                                onClick={() => setOpenAgentNote(false)} // Close modal on click
                            >
                                No
                            </div>
                            <div
                                onClick={() => setOpenAgentNote(false)}
                                className="px-4 py-1 rounded-lg text-blue-500 text-sm border-none outline-none tracking-wide active:bg-blue-600 cursor-pointer"
                            >
                                Confirm
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {exportConfirm && (
                    <div className="fixed inset-0 p-2 flex flex-wrap justify-center items-center w-full h-full z-[1000] before:fixed before:inset-0 before:w-full before:h-full before:bg-[rgba(0,0,0,0.5)] overflow-auto font-[sans-serif]">
                    <div className="w-[500px] max-w-lg bg-white shadow-lg rounded-lg p-4 relative">

                        <div className="flex justify-center text-[#5a5655] text-[14px]" style={{ fontFamily: 'Liberation Serif' }}>
                            Export User information
                        </div>

                        <div className="border-t border-gray-300 pt-1 flex justify-around gap-4" style={{ fontFamily: 'Liberation Serif' }}>
                            <div
                                className="px-4 py-1 rounded-lg text-[#5a5655] text-sm border-none outline-none tracking-wide active:bg-gray-200 cursor-pointer"
                                onClick={() => setExportConfirm(false)}
                            >
                                No
                            </div>
                            <div
                                className="px-4 py-1 rounded-lg text-blue-500 text-sm border-none outline-none tracking-wide active:bg-blue-600 cursor-pointer"
                                onClick={handleExport}
                            >
                                Confirm
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {exportAllConfirm && (
                    <div className="fixed inset-0 p-2 flex flex-wrap justify-center items-center w-full h-full z-[1000] before:fixed before:inset-0 before:w-full before:h-full before:bg-[rgba(0,0,0,0.5)] overflow-auto font-[sans-serif]">
                    <div className="w-[500px] max-w-lg bg-white shadow-lg rounded-lg p-4 relative">

                        <div className="flex justify-center text-[#5a5655] text-[14px]" style={{ fontFamily: 'Liberation Serif' }}>
                            Export All User information
                        </div>

                        <div className="border-t border-gray-300 pt-1 flex justify-around gap-4" style={{ fontFamily: 'Liberation Serif' }}>
                            <div
                                className="px-4 py-1 rounded-lg text-[#5a5655] text-sm border-none outline-none tracking-wide active:bg-gray-200 cursor-pointer"
                                onClick={() => setExportAllConfirm(false)}
                            >
                                No
                            </div>
                            <div
                                className="px-4 py-1 rounded-lg text-blue-500 text-sm border-none outline-none tracking-wide active:bg-blue-600 cursor-pointer"
                                onClick={handleAllUserExport}
                            >
                                Confirm
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {openDeleteConfirm && (
                    <div className="fixed inset-0 p-2 flex flex-wrap justify-center items-center w-full h-full z-[1000] before:fixed before:inset-0 before:w-full before:h-full before:bg-[rgba(0,0,0,0.5)] overflow-auto font-[sans-serif]">
                    <div className="w-[500px] max-w-lg bg-white shadow-lg rounded-lg p-4 relative">

                        <div className="flex justify-center text-[#5a5655] text-[17px] mt-3 mb-3" style={{ fontFamily: 'Liberation Serif' }}>
                            Are you sure you want to delete this item?
                        </div>

                        <div className="border-t border-gray-300 pt-1 flex justify-around gap-4" style={{ fontFamily: 'Liberation Serif' }}>
                            <div
                                className="px-4 py-1 rounded-lg text-[#5a5655] text-sm border-none outline-none tracking-wide active:bg-gray-200 cursor-pointer"
                                onClick={() => setOpenDeleteConfirm(false)}
                            >
                                No
                            </div>
                            <div
                                className="px-4 py-1 rounded-lg text-blue-500 text-sm border-none outline-none tracking-wide active:bg-blue-600 cursor-pointer"
                                onClick={handleUserDelete}
                            >
                                Confirm
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
export default UserList;